import { Spinner } from "@digdir/designsystemet-react";
import { createFileRoute } from "@tanstack/react-router";
import {
  PasswordProtection,
  useShouldShowPasswordProtection,
} from "@/components/PasswordProtection";
import { useAuth } from "@/features/auth";

// TODO password: Fjern denne filen når passordbeskyttelse er fjernet
export const Route = createFileRoute("/auth/logg-inn")({
  component: RouteComponent,
  pendingComponent: () => <Spinner aria-label="Laster passordbeskyttelse" />,
  head: () => ({
    meta: [
      {
        title: "Logger inn | Norgespris for Fjernvarme",
      },
    ],
  }),
});

function RouteComponent() {
  const { signinRedirect } = useAuth();
  const passwordProtection = useShouldShowPasswordProtection();

  if (passwordProtection.passwordIsRequired && !passwordProtection.hasAccess) {
    return <PasswordProtection />;
  }
  signinRedirect();
  return <Spinner aria-label="Logger inn..." />;
}
